<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'zhenyun-layout',
  props: [],
  data() {
    return {
      //
    };
  },
  methods: {
    //
  },
  mounted() {
    //
  }
};
</script>

<style scoped>
/* SCSS or CSS here */
</style>